export const PLAN_TYPES = {
  ESENTIAL: 0,
  PREFERRED: 1,
  ULTIMATE: 2,
};

export const MULTIMODAL_SECTIONS = {
  needToKnow: 1,
  petProtectCopay: 4,
  termsAndConditions: 3,
  vetExamFees: 5,
  wellnessDetails: 2,
};
